import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-view-chats',
  templateUrl: './ticket-view-chats.component.html',
  styleUrls: ['./ticket-view-chats.component.css']
})
export class InternalResponseTicketViewChatsComponent implements OnInit {
  @Input() chatList:any[]
  constructor() { }

  ngOnInit() {};


  formatMsg(data: string): { type: string; meta: string } {
    if (data) {
      if (
        data &&
        (data.startsWith("==image/jpeg") ||
          data.startsWith("==video/mp4") ||
          data.startsWith("==audio/ogg"))
      ) {
        return { type: data.split("==")[1], meta: data.split("+")[1] };
      } else {
        return { type: "text", meta: data };
      }
    } else {
      return { type: "text", meta: null };
    }
  }

  formatDiv(text: string){
    if (!text) return '';
    return text.replace(/\n/g, '<br>');
  }

}
